import "./Home.scss";
import React, { useState, useRef } from 'react';
import Nav from 'react-bootstrap/Nav';
import PopularTravelItineraries from './../shared/common/PopularTravelItineraries';
import TopDestinationItineraries from './../shared/common/TopDestinationItineraries';
import SponsoredSlider from './../shared/common/SponsoredSlider';
import PrivateItinerary from "./components/private-itinerary/PrivateItinerary";
import PublicItinerary from "./components/public-itinerary/PublicItinerary";
import { HomeSlider } from "./components/home-slider/HomeSlider";
import { scroller } from "react-scroll";
import { FilterBar } from "./components/filter-bar/FilterBar";
import { PageShowTotal } from "../../../components/pagination";
import { SortingSelect } from "./components/filter-bar/SortingSelect";

const Home = () => {
    const travellerTypes = ['Solo', 'Couple', 'Family', 'Group'];
    const ratingTypes = ['5', '5-4', '4-3', '3-2', '2-1'];
    const sortingTypes = ['Recent', 'Popularity', 'Price (Low to High)', 'Price (High to Low)'];
    const [defaultMaxPrice, setDefaultMaxPrice] = useState();
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [existingTripBtn, setExistingTripBtn] = useState(false);
    const [tabsKey, setTabsKey] = useState('Public');
    const clearPublicRef = useRef();
    const clearAllFilterRef = useRef();

    const filterDefault = {
        travellerType: [],
        travellerRating: [],
        priceRange: { min: 1, max: defaultMaxPrice ? defaultMaxPrice : 10000 },
        dayRange: { min: 1, max: 60 },
        dateRange: { startDate: new Date(), endDate: new Date(), key: 'selection', status: false },
        country: "",
        city: [],
        sortType: "Recent"
    }
    
    const [filters, setFilters] = useState(filterDefault);
    // For pagination
    const [sizePaginate, setSizePaginate] = useState(10);
    const [currentPaginate, setCurrentPaginate] = useState(1);
    const [totalItinerary, setTotalItinerary] = useState(0);

    const perPageChange = (value) => {
        setSizePaginate(value);
        const newPerPage = Math.ceil(totalItinerary / value);
        if (currentPaginate > newPerPage) {
            setCurrentPaginate(newPerPage);
        }
    }
    const paginationChange = (page, pageSize) => {
        setCurrentPaginate(page);
        setSizePaginate(pageSize);
    }

    // For tabs 
    const handleSelectTabs = (T) => {
        setTabsKey(T);
        setExistingTripBtn(false);
        setCurrentPaginate(1);
        if (tabsKey == 'Public') {
            clearPublicRef?.current?.clearPublicFilter();
        }
    }

    // Customize Existing Trip Fnc
    const customizeTripTogggle = () => {
        setExistingTripBtn(true);
        scroller.scrollTo("customizeExistingTrip", {
            duration: 100,
            delay: 0,
            offset: -100,
            smooth: "easeInOutQuart",
        });
    };

    const handleClearFilters = () => {
        clearAllFilterRef?.current?.clearAllFiltersFnc();
    }

    // console.log("clearAllFilterRef===>", clearAllFilterRef.current)

    return (
        <>
            <section className="home-banner-wrapper">
                <HomeSlider toggleTrip={customizeTripTogggle} />
            </section>

            <section className="pti-hold-wrap padd-top-70 padd-bottom-70 customizeExistingTrip">
                <div className="container-lg">
                    <div className="d-none d-xl-block mb-3">
                        <FilterBar
                            ref={clearAllFilterRef}
                            filters={filters}
                            setFilters={setFilters}
                            filterDefault={filterDefault}
                            setCurrentPaginate={setCurrentPaginate}
                            defaultMaxPrice={defaultMaxPrice}
                            showFilterModal={showFilterModal}
                            setShowFilterModal={setShowFilterModal}
                            travellerTypes={travellerTypes}
                            ratingTypes={ratingTypes}
                            sortingTypes={sortingTypes}
                        />
                    </div>
                    <div className="tabs-box d-lg-flex justify-content-between d-block">
                        <Nav variant="pills" className="home-nav-tabs" activeKey={tabsKey} onSelect={(T) => handleSelectTabs(T)}>
                            <Nav.Item>
                                <Nav.Link eventKey="Public">Public Itineraries</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="Private">Private Itineraries</Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <div className="right-sort-wrap d-flex align-items-center">
                            <PageShowTotal
                                currentPage={currentPaginate}
                                pageSize={sizePaginate}
                                totalItems={totalItinerary}
                            />
                            <span className="separator d-none d-xl-block"></span>
                            <span className="filter-clear-btn d-none d-xl-block" onClick={handleClearFilters}>
                                Clear all filters
                            </span>
                            <span className="d-none d-xl-block">
                                <SortingSelect
                                    filters={filters}
                                    setFilters={setFilters}
                                    sortingTypes={sortingTypes}
                                />
                            </span>
                            <button className="btn d-flex d-xl-none btn-filter ms-2" onClick={() => setShowFilterModal(true)}>
                                <i className="bi bi-sliders me-1"></i> Filters
                            </button>
                        </div>

                    </div>

                    {tabsKey === "Public" && (
                        <PublicItinerary
                            ref={clearPublicRef}
                            showExisting={existingTripBtn}
                            filters={filters}
                            setFilters={setFilters}
                            setTotalItinerary={setTotalItinerary}
                            perPageChange={perPageChange}
                            paginationChange={paginationChange}
                            sizePaginate={sizePaginate}
                            currentPaginate={currentPaginate}
                            setDefaultMaxPrice={setDefaultMaxPrice}
                        />
                    )}
                    {tabsKey === "Private" && (
                        <PrivateItinerary
                            filters={filters}
                            setFilters={setFilters}
                            setTotalItinerary={setTotalItinerary}
                            perPageChange={perPageChange}
                            paginationChange={paginationChange}
                            sizePaginate={sizePaginate}
                            currentPaginate={currentPaginate}
                            setDefaultMaxPrice={setDefaultMaxPrice}
                        />
                    )}

                </div>
            </section >
            <div className="container-lg">
                <hr className="mt-0 mb-0" />
            </div>
            <section className="pti-hold-wrap padd-top-70 padd-bottom-70">
                <div className="container-lg">
                    <PopularTravelItineraries />
                </div>
            </section>
            <section className="tdf-hold-wrap padd-bottom-70">
                <div className="container-lg">
                    <TopDestinationItineraries />
                </div>
            </section>
            {/* <section className="sponsered-hold-wrap padd-bottom-70">
                <div className="container-lg">
                    <SponsoredSlider />
                </div>
            </section> */}
            {/* <section className="subscribe-hold-wrap padd-top-80 padd-bottom-80">
                <div className="container-lg">
                    <div className="flex-subscribe">
                        <span className="subscribe-shap-3"></span>
                        <span className="subscribe-shap subscribe-shap-1"></span>
                        <div className="subscribe-info">
                            <h3>Subscribe to get information, latest news and other interesting offers about Travey Club </h3>
                        </div>
                        <div className="subscribe-box">
                            <div className="subscribe-input-field">
                                <i className="email-icon"></i>
                                <input type="email" className="form-control" placeholder="Your email" id="subscribeEmail" />
                            </div>
                            <button className="btn btn-primary-color" type="submit">Subscribe</button>
                        </div>
                        <span className="subscribe-shap subscribe-shap-2"></span>
                    </div>
                </div>
            </section> */}
        </>
    );

}

export default Home;
